import {
  Component,
  EventEmitter,
  Input,
  Output,
  QueryList
} from '@angular/core';

import { SkyTabComponent } from './tab.component';


export class SkyTabDropdownComponent {
  
  public tabs: QueryList<SkyTabComponent>;

  
  public tabClick = new EventEmitter<SkyTabComponent>();

  
  public closeClick = new EventEmitter<SkyTabComponent>();

  public get activeTabHeading(): string {
    let activeTab = this.tabs.filter((item) => {
      return item.active;
    });

    /*istanbul ignore else */
    if (activeTab.length > 0) {
      return activeTab[0].tabHeading;
    }
    /* istanbul ignore next */
    /* sanity check */
    return '';
  }

  public selectTab(tab: SkyTabComponent) {
    if (!tab.disabled) {
      this.tabClick.emit(tab);
    }
  }

  public closeTab(tab: SkyTabComponent) {
    this.closeClick.emit(tab);
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-tab-dropdown',
  template: `<div class="sky-tab-dropdown">
  <sky-dropdown buttonType="tab">
    <sky-dropdown-button>
      {{ activeTabHeading }}
    </sky-dropdown-button>
    <sky-dropdown-menu>
      <sky-dropdown-item
        *ngFor="let tab of tabs">
        <div
          class="sky-tab-dropdown-item"
          [ngClass]="{ 'sky-tab-dropdown-item-selected': tab.active }">
          <button
            type="button"
            class="sky-btn sky-tab-dropdown-item-btn"
            [ngClass]="{ 'sky-btn-disabled': tab.disabled }"
            (click)="selectTab(tab)">
            {{ tab.tabHeading }}
          </button>
          <button
            type="button"
            class="sky-btn sky-tab-dropdown-item-close"
            *ngIf="tab.allowClose"
            (click)="closeTab(tab)">
            <i class="fa fa-remove"></i>
          </button>
        </div>
      </sky-dropdown-item>
    </sky-dropdown-menu>
  </sky-dropdown>
</div>
`,
  styles: [`.sky-tab-dropdown ::ng-deep .sky-dropdown-item {
  margin: 0;
}

.sky-tab-dropdown-button {
  max-width: 300px;
}

.sky-tab-dropdown-item {
  display: flex;
  padding: 0;
  transition: background-color 150ms;
  min-width: 300px;
}

.sky-tab-dropdown-item:hover:not(.sky-tab-dropdown-item-selected) {
  background-color: #eeeeef;
}

.sky-tab-dropdown-item-btn {
  border: none;
  background-color: transparent;
  cursor: pointer;
  flex-grow: 1;
  padding: 10px;
  text-align: left;
}

.sky-tab-dropdown-item-close {
  background-color: transparent;
  border: none;
  padding: 10px;
}

.sky-tab-dropdown-item-selected {
  background-color: #007ca6;
}

.sky-tab-dropdown-item-selected:hover {
  background-color: #007ca6;
}

.sky-tab-dropdown-item-selected .sky-tab-dropdown-item-btn,
.sky-tab-dropdown-item-selected .sky-tab-dropdown-item-close {
  color: #fff;
}
`]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'tabs': [{ type: Input },],
'tabClick': [{ type: Output },],
'closeClick': [{ type: Output },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
